const header = document.querySelector("[data-header]");
const toggle = document.querySelector("[data-menu-toggle]");
const nav = document.querySelector("[data-nav]");
const newsletter = document.querySelector("[data-newsletter]");
const newsletterMessage = document.querySelector("[data-newsletter-message]");
let newsletterPopup = document.querySelector("[data-newsletter-popup]");
const hero = document.querySelector(".hero");
const collectionGrid = document.querySelector(".collection-grid");
const mensProducts = document.querySelector(".mens-products");
const mensHeroTitle = document.querySelector(".mens-hero-copy h1");
const womensHeroTitle = document.querySelector(".womens-hero-copy h1");
const mensCollectionLead = document.querySelector(".mens-collection-lead");
const aboutHero = document.querySelector(".about-elephant-hero");
const aboutHeroTitle = document.querySelector(".about-elephant-hero h1");
const aboutStoryPanels = document.querySelectorAll(".about-story-panel");
const revealItems = document.querySelectorAll(".collection-card, .product-card");
const editorialRevealItems = document.querySelectorAll(".mens-collection-lead, .about-starry-section, .about-story-panel");

const updateHeader = () => {
  const heroBottom = hero ? hero.offsetHeight - header.offsetHeight : 16;
  header.classList.toggle("is-scrolled", window.scrollY > heroBottom);
};

const updateHeroTitle = () => {
  if (!hero) return;

  const rawProgress = Math.min(Math.max(window.scrollY / hero.offsetHeight, 0), 1);
  const progress = Math.min(Math.max(window.scrollY / (hero.offsetHeight * 1.15), 0), 1);
  const eased = 1 - Math.pow(1 - progress, 3);
  const blackoutStart = 0.6;
  const blackoutProgress = Math.min(Math.max((rawProgress - blackoutStart) / (1 - blackoutStart), 0), 1);
  const blackoutEase = blackoutProgress * blackoutProgress * (3 - 2 * blackoutProgress);

  document.documentElement.style.setProperty("--title-slide", eased.toFixed(3));
  document.documentElement.style.setProperty("--hero-blackout", blackoutEase.toFixed(3));
  document.documentElement.style.setProperty("--tagline-scale", (1 + rawProgress * 1.15).toFixed(3));
  document.documentElement.style.setProperty("--tagline-opacity", (1 - blackoutEase).toFixed(3));
};

const updateMensHero = () => {
  if (!document.body.classList.contains("mens-page") || !hero) return;

  const progress = Math.min(Math.max(window.scrollY / hero.offsetHeight, 0), 1);
  const zoom = 1 + progress * 0.16;
  const blackoutStart = 0.5;
  const blackoutProgress = Math.min(Math.max((progress - blackoutStart) / (1 - blackoutStart), 0), 1);
  const blackoutEase = blackoutProgress * blackoutProgress * (3 - 2 * blackoutProgress);

  document.documentElement.style.setProperty("--mens-hero-zoom", zoom.toFixed(3));
  document.documentElement.style.setProperty("--mens-hero-blackout", (blackoutEase * 0.94).toFixed(3));

  if (mensHeroTitle) {
    const titleBottom = mensHeroTitle.getBoundingClientRect().bottom;
    const handoffDistance = Math.max(header.offsetHeight * 0.9, 64);
    const fadeProgress = Math.min(Math.max((header.offsetHeight - titleBottom) / handoffDistance, 0), 1);
    const easedProgress = fadeProgress * fadeProgress * (3 - 2 * fadeProgress);

    document.documentElement.style.setProperty("--mens-title-opacity", (1 - easedProgress).toFixed(3));
    document.documentElement.style.setProperty("--mens-header-title-opacity", easedProgress.toFixed(3));
    document.documentElement.style.setProperty("--mens-header-title-lift", `${((1 - easedProgress) * 8).toFixed(2)}px`);
    header.classList.toggle("mens-title-active", easedProgress > 0.12);
  }
};

const updateWomensHero = () => {
  if (!document.body.classList.contains("womens-page") || !hero) return;

  if (womensHeroTitle) {
    const titleBottom = womensHeroTitle.getBoundingClientRect().bottom;
    const handoffDistance = Math.max(header.offsetHeight * 0.9, 64);
    const fadeProgress = Math.min(Math.max((header.offsetHeight - titleBottom) / handoffDistance, 0), 1);
    const easedProgress = fadeProgress * fadeProgress * (3 - 2 * fadeProgress);

    document.documentElement.style.setProperty("--womens-title-opacity", (1 - easedProgress).toFixed(3));
    document.documentElement.style.setProperty("--womens-header-title-opacity", easedProgress.toFixed(3));
    document.documentElement.style.setProperty("--womens-header-title-lift", `${((1 - easedProgress) * 8).toFixed(2)}px`);
    header.classList.toggle("womens-title-active", easedProgress > 0.12);
  }
};

const updateMensCollectionLine = () => {
  if (!mensCollectionLead) return;

  const rect = mensCollectionLead.getBoundingClientRect();
  const progress = Math.min(Math.max((window.innerHeight * 0.68 - rect.top) / (window.innerHeight * 0.55), 0), 1);

  document.documentElement.style.setProperty("--mens-line-progress", progress.toFixed(3));

  mensCollectionLead.querySelectorAll("p").forEach((sentence, index) => {
    const start = index * 0.24;
    const sentenceProgress = Math.min(Math.max((progress - start) / 0.22, 0), 1);
    const eased = sentenceProgress * sentenceProgress * (3 - 2 * sentenceProgress);

    sentence.style.setProperty("--sentence-opacity", eased.toFixed(3));
  });
};

const updateAboutHero = () => {
  if (!aboutHero) return;

  const rect = aboutHero.getBoundingClientRect();
  const progress = Math.min(Math.max(-rect.top / aboutHero.offsetHeight, 0), 1);
  const scale = 1.12 - progress * 0.12;

  document.documentElement.style.setProperty("--about-hero-scale", scale.toFixed(3));

  if (aboutHeroTitle) {
    const titleTop = aboutHeroTitle.getBoundingClientRect().top;
    const handoffDistance = Math.max(header.offsetHeight * 1.1, 72);
    const fadeProgress = Math.min(Math.max((header.offsetHeight - titleTop) / handoffDistance, 0), 1);
    const easedProgress = fadeProgress * fadeProgress * (3 - 2 * fadeProgress);

    document.documentElement.style.setProperty("--about-title-opacity", (1 - easedProgress).toFixed(3));
    document.documentElement.style.setProperty("--about-header-title-opacity", easedProgress.toFixed(3));
    document.documentElement.style.setProperty("--about-header-title-lift", `${((1 - easedProgress) * 8).toFixed(2)}px`);
    header.classList.toggle("about-title-active", easedProgress > 0.12);
  }
};

const updateAboutStoryPanels = () => {
  if (!aboutStoryPanels.length) return;

  aboutStoryPanels.forEach((panel) => {
    const rect = panel.getBoundingClientRect();
    const progress = Math.min(Math.max((window.innerHeight - rect.top) / (window.innerHeight + rect.height), 0), 1);
    const centerDistance = Math.abs(rect.top + rect.height / 2 - window.innerHeight / 2);
    const focus = 1 - Math.min(centerDistance / (window.innerHeight * 0.72), 1);
    const easedFocus = focus * focus * (3 - 2 * focus);
    const imageLift = (0.5 - progress) * 54;
    const textLift = (1 - easedFocus) * 26;

    panel.style.setProperty("--about-panel-focus", easedFocus.toFixed(3));
    panel.style.setProperty("--about-panel-image-lift", `${imageLift.toFixed(2)}px`);
    panel.style.setProperty("--about-panel-text-lift", `${textLift.toFixed(2)}px`);
  });
};

toggle?.addEventListener("click", () => {
  const isOpen = header.classList.toggle("is-open");
  toggle.setAttribute("aria-expanded", String(isOpen));
});

nav?.addEventListener("click", (event) => {
  if (event.target.matches("a")) {
    header.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
  }
});

newsletter?.addEventListener("submit", (event) => {
  if (!newsletter.getAttribute("action")) {
    event.preventDefault();
    newsletterMessage.textContent = "Thank you. Future chapters will find you.";
    newsletter.reset();
  }
});

const initNewsletterPopup = () => {
  if (!newsletterPopup) return;

  const popupForm = newsletterPopup.querySelector("[data-newsletter-popup-form]");
  const popupMessage = newsletterPopup.querySelector("[data-newsletter-popup-message]");
  const popupInput = newsletterPopup.querySelector("input");
  const forcePreview = new URLSearchParams(window.location.search).has("newsletter-preview");
  const hasDismissed = !forcePreview && sessionStorage.getItem("maisonKeraNewsletterPopup") === "dismissed";

  const closePopup = () => {
    newsletterPopup.classList.remove("is-visible");
    sessionStorage.setItem("maisonKeraNewsletterPopup", "dismissed");
  };

  if (!hasDismissed) {
    window.setTimeout(() => {
      newsletterPopup.classList.add("is-visible");
      popupInput?.focus({ preventScroll: true });
    }, 900);
  }

  newsletterPopup.querySelectorAll("[data-newsletter-popup-close]").forEach((button) => {
    button.addEventListener("click", closePopup);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && newsletterPopup.classList.contains("is-visible")) {
      closePopup();
    }
  });

  popupForm?.addEventListener("submit", () => {
    sessionStorage.setItem("maisonKeraNewsletterPopup", "dismissed");
    popupMessage.textContent = "Thank you. Future chapters will find you.";
  });
};

initNewsletterPopup();

document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
  const track = gallery.querySelector(".product-gallery-track");
  const previous = gallery.querySelector("[data-gallery-prev]");
  const next = gallery.querySelector("[data-gallery-next]");
  const productDetail = gallery.closest(".product-detail");

  const moveGallery = (direction) => {
    if (!track) return;

    track.scrollBy({
      left: direction * track.clientWidth,
      behavior: "smooth",
    });
  };

  previous?.addEventListener("click", () => moveGallery(-1));
  next?.addEventListener("click", () => moveGallery(1));

  productDetail?.querySelectorAll("[data-colour-option]").forEach((option) => {
    option.addEventListener("change", () => {
      if (!option.checked || !track) return;

      const selectedColour = option.value.toLowerCase().replace(/[^a-z0-9]/g, "");
      const targetImage = Array.from(track.querySelectorAll("img")).find((image) => {
        const colour = image.dataset.colour || image.alt || "";
        return colour.toLowerCase().replace(/[^a-z0-9]/g, "").includes(selectedColour);
      });

      targetImage?.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
    });
  });
});

const updateCollectionSpotlight = () => {
  if (!revealItems.length) return;

  const isDesktop = window.matchMedia("(min-width: 981px)").matches;
  const distanceFromBottom = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
  const shouldReleaseSpotlight = isDesktop && distanceFromBottom < window.innerHeight * 0.22;
  const viewportCenter = window.innerHeight * 0.52;
  let closestCard = null;
  let closestDistance = Infinity;

  if (!shouldReleaseSpotlight) {
    revealItems.forEach((item) => {
      if (!item.classList.contains("is-visible")) return;

      const rect = item.getBoundingClientRect();
      const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);

      if (visibleHeight <= rect.height * 0.28) return;

      const itemCenter = rect.top + rect.height / 2;
      const distance = Math.abs(itemCenter - viewportCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestCard = item;
      }
    });
  }

  revealItems.forEach((item) => {
    item.classList.toggle("is-spotlight", item === closestCard);
  });

  collectionGrid?.classList.toggle("has-spotlight", Boolean(closestCard));
  mensProducts?.classList.toggle("has-spotlight", Boolean(closestCard));
  document.body.classList.toggle("collection-spotlight-active", Boolean(closestCard));
};

if ("IntersectionObserver" in window) {
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
        } else {
          entry.target.classList.remove("is-visible");
        }
      });

      updateCollectionSpotlight();
    },
    { threshold: 0.18 }
  );

  revealItems.forEach((item) => revealObserver.observe(item));
  editorialRevealItems.forEach((item) => revealObserver.observe(item));
} else {
  revealItems.forEach((item) => item.classList.add("is-visible"));
  editorialRevealItems.forEach((item) => item.classList.add("is-visible"));
  updateCollectionSpotlight();
}


updateHeader();
updateHeroTitle();
updateMensHero();
updateWomensHero();
updateMensCollectionLine();
updateAboutHero();
updateAboutStoryPanels();
updateCollectionSpotlight();
window.addEventListener("scroll", updateHeader, { passive: true });
window.addEventListener("scroll", updateHeroTitle, { passive: true });
window.addEventListener("scroll", updateMensHero, { passive: true });
window.addEventListener("scroll", updateWomensHero, { passive: true });
window.addEventListener("scroll", updateMensCollectionLine, { passive: true });
window.addEventListener("scroll", updateAboutHero, { passive: true });
window.addEventListener("scroll", updateAboutStoryPanels, { passive: true });
window.addEventListener("scroll", updateCollectionSpotlight, { passive: true });
window.addEventListener("resize", updateHeader);
window.addEventListener("resize", updateHeroTitle);
window.addEventListener("resize", updateMensHero);
window.addEventListener("resize", updateWomensHero);
window.addEventListener("resize", updateMensCollectionLine);
window.addEventListener("resize", updateAboutHero);
window.addEventListener("resize", updateAboutStoryPanels);
window.addEventListener("resize", updateCollectionSpotlight);
